module.exports = __webpack_public_path__ + "img/home-compare.f33d1bf.webp";